import { render } from "./mapPresta.vue?vue&type=template&id=5a61693f"
import script from "./mapPresta.vue?vue&type=script&lang=ts"
export * from "./mapPresta.vue?vue&type=script&lang=ts"
script.render = render

export default script